module.exports = __webpack_public_path__ + "static/4-1c49d001e99d962e921720d6f6b6a3fd.jpeg";